export default __webpack_public_path__ + "static/media/Glassdoor.7ea30149.svg";